module.exports = __webpack_public_path__ + "static/media/mspa-poc-all-users.7ce28950.png";